<elder-basic-pane-layout class="full">
  <elder-pane>
    <elder-pane-content>
      <elder-table
        class="flex"
        [data]="data"
        [idField]="'id'"
        matSort
        (itemClick)="openDetail($event)"
      >
        <!-- icon Column -->
        <ng-container matColumnDef="icon">
          <th mat-header-cell *matHeaderCellDef style="width: 30px"></th>
          <td mat-cell *matCellDef="let order">
            <mat-icon [color]="determineIconColor(order)">
              {{ determineIcon(order) }}
            </mat-icon>
          </td>
        </ng-container>

        <!-- scheduleInterval Column -->
        <ng-container matColumnDef="scheduleInterval">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'processing.planned' | translate }}
          </th>
          <td mat-cell *matCellDef="let order">
            {{
              (order?.scheduleInterval | isoIntervalParse)?.start?.toString() | date: 'dd.MM.yyyy'
            }}
          </td>
        </ng-container>

        <!-- priority Column -->
        <ng-container matColumnDef="priority">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'context.priority' | translate }}
          </th>
          <td mat-cell *matCellDef="let order">
            <div class="layout-row place-start-center gap-sm">
              <span class="mat-subtitle-2">
                {{ order.priority }}
              </span>

              @if (
                order.orderPriority === ProdOrderPriority.HIGH ||
                order.orderPriority === ProdOrderPriority.LOW
              ) {
                <mat-chip-set>
                  <mat-chip highlighted>
                    <div class="layout-col place-center-center">
                      <span>{{ 'orders.orderPriority.' + order.orderPriority | translate }}</span>
                    </div>
                  </mat-chip>
                </mat-chip-set>
              }
            </div>
          </td>
        </ng-container>

        <!-- workOrder Column -->
        <ng-container matColumnDef="workOrderId">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'orders.work.order' | translate }}
          </th>
          <td mat-cell *matCellDef="let order">{{ order.workOrderId }}</td>
        </ng-container>

        <!-- inter-site Column -->
        <ng-container matColumnDef="inter-site">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'facilities.facilities' | translate }}
          </th>
          <td mat-cell *matCellDef="let order">
            <div class="flex layout-row gap-lg place-start-center">
              @if (order.processingFacility !== order.collectingFacility) {
                <div class="layout-row place-start-center gap-lg">
                  <span>{{ order.processingFacility }}</span>
                  <mat-icon color="warn">east</mat-icon>
                </div>
              }
              <span>{{ order.collectingFacility }}</span>
            </div>
          </td>
        </ng-container>

        <!-- itemCount Column -->
        <ng-container matColumnDef="itemCount">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'context.items' | translate }}
          </th>
          <td mat-cell *matCellDef="let order">
            @if (isItemCountDifferent(order)) {
              <div>{{ order.matchedItemsAgg.itemCount }} ({{ order.totalItemsAgg.itemCount }})</div>
            } @else {
              {{ order.totalItemsAgg.itemCount }}
            }
          </td>
        </ng-container>

        <!-- piecesCount Column -->
        <ng-container matColumnDef="piecesCount">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'context.pieces' | translate }}
          </th>
          <td mat-cell *matCellDef="let order">
            @if (isItemCountDifferent(order)) {
              <div>{{ order.matchedItemsAgg.pieces }} ({{ order.totalItemsAgg.pieces }})</div>
            } @else {
              {{ order.totalItemsAgg.pieces }}
            }
          </td>
        </ng-container>

        <!-- weight Column -->
        <ng-container matColumnDef="weight">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'context.weight' | translate }}
          </th>
          <td mat-cell *matCellDef="let order">
            @if (isItemCountDifferent(order)) {
              <div>
                {{ order.matchedItemsAgg.weight | elderQuantity }} ({{
                  order.totalItemsAgg.weight | elderQuantity
                }})
              </div>
            } @else {
              {{ order.totalItemsAgg.weight | elderQuantity }}
            }
          </td>
        </ng-container>

        <!-- bundle Column
    <ng-container matColumnDef="bundle">
      <th mat-header-cell *matHeaderCellDef>{{'context.bundle' | translate}}</th>
      <td mat-cell *matCellDef="let order"> {{order.bundle}} </td>
    </ng-container>
    -->

        <!-- status Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'context.status' | translate }}
          </th>
          <td mat-cell *matCellDef="let order">
            <span class="mat-subtitle-2">{{
              'work_order_completion_state.' + order.completionState | translate
            }}</span>
          </td>
        </ng-container>
      </elder-table>
    </elder-pane-content>
  </elder-pane>
</elder-basic-pane-layout>
